<script>
    let bestmovieDatas = [
        {id: 1, link: 'y7BOpZebwmo'},
        {id: 2, link: 'pkiTryZ1Cnc'},
        {id: 3, link: 'x2YMQgbeWRQ'},
    ]
</script>

<ul class="bestmovielist">
    {#each bestmovieDatas as bestmovieData (bestmovieData.id)}
    <li class="bestmovielist__item">
        <div class="bestmovielist__ranking">
            <span>Ranking</span>
            <span><strong>{bestmovieData.id}</strong></span>
        </div>
        <iframe src="https://www.youtube.com/embed/{bestmovieData.link}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </li>
    {/each}
</ul>

<style>
    .bestmovielist__item {
        border: 1px solid var(--color-border);
        border-radius: 5px;
        position: relative;
        height: 0;
        padding-top: 56.25%;
        overflow: hidden;
    }
    .bestmovielist__item + .bestmovielist__item {
        margin-top: 10px;
    }
    .bestmovielist__item iframe {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px;
    }
    .bestmovielist__ranking {
        background: var(--color-secondary);
        padding: 50px 10px 15px 10px;
        margin-top: -35px;
        font-size: 12px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 10px;
        display:flex;
        align-items: center;
        flex-direction: column;
        z-index: 5;
        border-radius: 100px;
    }
    .bestmovielist__ranking strong {
        font-size: 30px;
        font-weight: 700;
    }
</style>